import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import googleLogin from "../../firebase/auth";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

async function login() {
  const res = await googleLogin();

  if (res.error) {
    return;
  }

  store.dispatch("UserStore/setCurrentUser", res.currentUser);
  router.replace("home");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("button", {
      type: "text",
      onClick: login
    }, "Google Login")
  ]))
}
}

})